import { Bonuses } from '../bonuses/containers/bonuses';
import { FreeBets } from '../free-bets/containers/free-bets';
import { FreeSpins } from '../free-spins/containers/free-spins';
import { ContextNavigate } from '../shared/components/context-navigate/context-navigate';

export default [
    {
        path: 'bonuses',
        element: <Bonuses />,
    },
    {
        path: 'free-bets',
        element: <FreeBets />,
    },
    {
        path: 'free-spins',
        element: <FreeSpins />,
    },
    {
        path: '*',
        index: true,
        element: <ContextNavigate to={'/account/rewards/bonuses'} replace />,
    },
];
